export const AUTH_TOKEN_STORAGE_KEY = 'commonsense.authToken';
export const AUTH_ROLE_STORAGE_KEY = 'commonsense.authRole';
export const AUTH_FIRST_NAME_STORAGE_KEY = 'commonsense.authFirstName';
export const AUTH_NEEDS_BROKERAGE_STORAGE_KEY = 'commonsense.needsBrokerage';
export const AUTH_DEVELOPER_STORAGE_KEY = 'commonsense.developer';
export const AUTH_PASSWORD_DAYS_LEFT_STORAGE_KEY = 'commonsense.passwordDaysLeft';
